module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/martyna-stanczyk-16c36cce134c8f12af863cb8831be4fb.png";